var _circle, _circle2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJaHip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_3212",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_3212)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3998,
    cy: 26.743,
    rx: 5.48571,
    ry: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.51367,
    y: 26.7427,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(60 6.51367 26.7427)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.258819 -0.965926 -0.965926 -0.258819 6.51367 25.3716)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.866026 -0.5 -0.5 -0.866025 6.85645 22.6284)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1613 17.4318C35.2483 14.7575 34.3863 12.2308 34.5227 7.85539C34.528 7.68697 34.4658 7.52335 34.3499 7.40054C34.234 7.27772 34.0739 7.20577 33.9047 7.20051C33.7355 7.19524 33.5712 7.2571 33.4478 7.37247C33.3244 7.48784 33.2522 7.64728 33.2469 7.8157C33.1041 12.4197 34.0442 15.1766 34.9532 17.8398C36.3885 22.0572 37.8812 26.4176 35.5991 38.6778C35.5838 38.7598 35.5848 38.844 35.6021 38.9256C35.6195 39.0072 35.6528 39.0846 35.7002 39.1533C35.7476 39.2221 35.8081 39.2809 35.8783 39.3264C35.9485 39.3719 36.0271 39.4031 36.1094 39.4184C36.1481 39.4253 36.1873 39.4288 36.2266 39.4287C36.3756 39.4286 36.5197 39.3767 36.6342 39.2818C36.7487 39.187 36.8262 39.0553 36.8534 38.9096C39.1961 26.3231 37.6531 21.8064 36.1613 17.4318Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0956 7.8157C15.093 7.73231 15.0739 7.65024 15.0394 7.57419C15.005 7.49814 14.9558 7.4296 14.8947 7.37247C14.7713 7.2571 14.607 7.19524 14.4378 7.20051C14.2686 7.20577 14.1085 7.27772 13.9926 7.40054C13.8767 7.52335 13.8146 7.68697 13.8198 7.85539C13.9562 12.2308 13.0942 14.7575 12.1812 17.4318C10.6894 21.8064 9.14644 26.3231 11.4931 38.9096C11.5203 39.0553 11.5978 39.187 11.7123 39.2818C11.8268 39.3767 11.9709 39.4286 12.1198 39.4287C12.1591 39.4288 12.1984 39.4253 12.2371 39.4184C12.3194 39.4031 12.3979 39.3719 12.4682 39.3264C12.5384 39.2809 12.5989 39.2221 12.6463 39.1533C12.6937 39.0846 12.727 39.0072 12.7443 38.9256C12.7617 38.844 12.7627 38.7598 12.7474 38.6778C10.4653 26.4176 11.95 22.0572 13.3932 17.8398C14.2983 15.1766 15.2408 12.4221 15.0956 7.8157Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9538 22.6368C14.788 22.6039 14.6159 22.6378 14.4752 22.7311C14.3345 22.8244 14.2368 22.9695 14.2035 23.1345C13.6652 25.8373 13.6652 28.619 14.2035 31.3218C14.2324 31.4655 14.3103 31.5949 14.4241 31.6879C14.5379 31.7809 14.6806 31.8319 14.8278 31.8322C14.8701 31.8321 14.9123 31.8281 14.9538 31.8203C15.036 31.8039 15.1141 31.7715 15.1837 31.725C15.2532 31.6786 15.313 31.6189 15.3594 31.5495C15.4058 31.4801 15.438 31.4022 15.4542 31.3203C15.4704 31.2385 15.4703 31.1543 15.4538 31.0725C14.949 28.5342 14.949 25.9221 15.4538 23.3838C15.4869 23.2187 15.4528 23.0474 15.3591 22.9073C15.2653 22.7672 15.1196 22.6699 14.9538 22.6368Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.013 31.5908C25.7963 32.0893 23.4958 32.0893 21.2791 31.5908C21.1971 31.5712 21.1119 31.568 21.0285 31.5813C20.9452 31.5947 20.8653 31.6244 20.7936 31.6688C20.7219 31.7131 20.6597 31.7711 20.6107 31.8396C20.5617 31.908 20.5268 31.9854 20.5081 32.0674C20.4894 32.1493 20.4872 32.2341 20.5016 32.317C20.516 32.3998 20.5469 32.4789 20.5922 32.5497C20.6376 32.6206 20.6967 32.6818 20.766 32.7297C20.8353 32.7777 20.9135 32.8115 20.9961 32.8291C21.9869 33.0525 22.9965 33.1838 24.0117 33.2213V38.7938C24.0117 38.9622 24.0789 39.1237 24.1986 39.2428C24.3182 39.3619 24.4805 39.4288 24.6496 39.4288C24.8188 39.4288 24.9811 39.3619 25.1007 39.2428C25.2203 39.1237 25.2875 38.9622 25.2875 38.7938V33.2213C26.3017 33.1835 27.3102 33.0522 28.3 32.8291C28.4632 32.7901 28.6044 32.6886 28.6929 32.5466C28.7814 32.4047 28.8102 32.2337 28.7729 32.0708C28.7357 31.9079 28.6355 31.7661 28.4939 31.6763C28.3524 31.5864 28.181 31.5557 28.0169 31.5908H28.013Z",
    fill: "#536479"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaHip);
export default __webpack_public_path__ + "static/media/ja_hip.b3bb13c6eff492e0352ad94006c61987.svg";
export { ForwardRef as ReactComponent };